module.exports = __webpack_public_path__ + "img/czqdkc-banner.1c7e9760.png";